import SignupForm from "../components/SignUpFrom/SignUpForm";
import { Header } from "../components/Header/Header";
export function SignUpPage () {
    return (
        <>
            <Header />
            <SignupForm />
        </>
    )
}